module.exports = __webpack_public_path__ + "static/media/poorly.d4fd890f.svg";